import { Cushion, MaxWidth } from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React from 'react';
import RosBottomBanner from '../../adverts/ros-bottom-banner';
import TopBannerVideoPlayerSwitch from '../../adverts/top-banner-video-player-switch';
import NativeShelf from '../../native-adverts/shelf';
import PROFILES_PROP_TYPES from '../../../lib/prop-types/profile';
import useBreakpoint from '../../../lib/use-breakpoint';
import MobileSubHeader from '../mobile-sub-header';
import NoResults from './no-results';
import ProfileGroup from './profile-group';
import SquadLoadingState from './squad-loading-state';

const SquadList = ({ club, teamId, isLoading, staffAndCoaches, players }) => {
  const renderSquad = () => {
    if (isLoading) {
      return <SquadLoadingState placeholdersLimit={15} />;
    }

    if (staffAndCoaches.length > 0 || players.length > 0) {
      return (
        <div>
          {staffAndCoaches.map((group) => {
            const { name, members } = group;
            return (
              <ProfileGroup
                key={`staff-and-coaches-${name}`}
                teamId={teamId}
                title={name}
                profiles={members}
              />
            );
          })}
          {staffAndCoaches.length > 0 && (
            <Cushion bottom="xlarge">
              <RosBottomBanner />
            </Cushion>
          )}
          {players.map((group) => {
            const { name, members } = group;
            return (
              <ProfileGroup
                key={`players-${name}`}
                teamId={teamId}
                title={name}
                profiles={members}
              />
            );
          })}
          {staffAndCoaches.length === 0 && (
            <Cushion bottom="xlarge">
              <RosBottomBanner />
            </Cushion>
          )}
        </div>
      );
    }

    return <NoResults />;
  };

  const { advertisingTier, sportId } = club;
  const isMobile = useBreakpoint();
  return (
    <MaxWidth component="div" maxWidth={1366} center>
      {isMobile && <MobileSubHeader title="Squad" transKey="teams:navigation_sqaud" />}
      <Cushion bottom="medium">
        <TopBannerVideoPlayerSwitch
          advertisingTier={advertisingTier}
          sportId={sportId}
          pageType="team.squad.index"
        />
      </Cushion>
      {renderSquad()}
      <NativeShelf paddingProps={{ bottom: 'medium' }} />
    </MaxWidth>
  );
};

SquadList.defaultProps = {
  staffAndCoaches: [],
  players: [],
};

SquadList.propTypes = {
  club: PropTypes.shape({
    advertisingTier: PropTypes.number.isRequired,
    sportId: PropTypes.number.isRequired,
  }).isRequired,
  teamId: PropTypes.number.isRequired,
  isLoading: PropTypes.bool.isRequired,
  staffAndCoaches: PROFILES_PROP_TYPES,
  players: PROFILES_PROP_TYPES,
};

export default SquadList;
